import React from 'react'
import { connect } from 'react-redux'
import {Container} from 'react-bootstrap'
import MultipleTableCuppings from './MultipleTableCuppings'
import {fetchUserTables} from '../../actions/actions'
import {CatoroSpinner} from '../CatoroSpinner'
import {Form} from 'react-bootstrap'

class UserTableCuppings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          setSort: "date",
          privateOnly: false,     
        }
      }

    componentDidMount(){
        this.props.fetchUserTables(this.props.user.id) 
    }

    handleSortChange = (event) => {
        this.setState({
        ...this.state,
            setSort: event.target.value,
        })
    }

    handlePrivateCheckbox = (event) => {
        this.setState({
            ...this.state,
                privateOnly: !this.state.privateOnly,
        })
    }

    sortUserTables = (dropDown, privateSort=false) => {
        if (dropDown === "date" && privateSort) {
            const privateDate = [].concat(this.props.userTables).filter(t =>
                t.public !== true
             )
             return privateDate
        } else if (dropDown === "az" && privateSort) {
            const privateName = [].concat(this.props.userTables).filter(t =>
                t.public !== true
             )
             
             if (privateName.length > 1) {
                privateName.sort((a, b) => a.name.localeCompare(b.name))
                return privateName
             } else {
                 return privateName
             }
        } else if (dropDown === "az") {
            const sortedByName = [].concat(this.props.userTables).sort((a, b) => a.name.localeCompare(b.name))
            return sortedByName
        }

    }

    renderResultsNum = (userTables) => {
        if (userTables) {
            return (
                <>
                <br></br><small style={{display: "block"}} className="w3-center"> <i> Showing {userTables.length} Cupping(s) </i> </small>  
                </>
            )
        }
    }

    renderUserCuppings = () => {
        switch(true) {
        case this.props.userTables.length > 3 && this.state.setSort === "date" && !!this.state.privateOnly:
            const sortedDatetrue = this.sortUserTables("date", true)
            return (
            <React.Fragment> 
                {this.renderResultsNum(sortedDatetrue)}   
                <MultipleTableCuppings tableCuppings={sortedDatetrue} isLoggedIn={this.props.isLoggedIn} />    
            </React.Fragment> 
            )
        case this.props.userTables.length >= 1 && this.state.setSort === "date":
            return (
            <React.Fragment> 
                {this.renderResultsNum(this.props.userTables)}
                <MultipleTableCuppings tableCuppings={this.props.userTables} isLoggedIn={this.props.isLoggedIn} /> 
            </React.Fragment>    
            )
        case this.props.userTables.length > 3 && this.state.setSort === "az" && !!this.state.privateOnly:  
            const sortedAZtrue = this.sortUserTables("az", true)
            return (
                <React.Fragment> 
                    {this.renderResultsNum(sortedAZtrue)}   
                    <MultipleTableCuppings tableCuppings={sortedAZtrue} isLoggedIn={this.props.isLoggedIn} /> 
                </React.Fragment>
            )
        case this.props.userTables.length > 3 && this.state.setSort === "az":
            const sortedUserTables = this.sortUserTables("az")
            return (
                <React.Fragment>
                    {this.renderResultsNum(sortedUserTables)}
                    <MultipleTableCuppings tableCuppings={sortedUserTables} isLoggedIn={this.props.isLoggedIn} />
                </React.Fragment>
            )
        default:
            return <p className="w3-center"><i>You haven't created any cupping tables yet :(</i></p> 
        }
            
    }

    filterCuppings = () => {
      if (this.props.userTables.length > 3) {  
        return (
            <Form>
                <Form.Group controlId="sortTables" className="scoreCuppingFormEl sorter w3-center" 
                style={{margin: "0 auto"}}
                name="sort"
                onChange={e => this.handleSortChange(e)} 
                >
                    <Form.Label>Sort By:</Form.Label>
                    <Form.Control as="select">
                    <option value="date">Date</option>
                    <option value="az">A-Z</option>
                    </Form.Control>
                </Form.Group>
                <Form.Check className="scoreCuppingFormEl sorter" style={{margin: "0 auto", fontSize: "0.9rem"}}
                    label="Show private only"
                    onChange={e => this.handlePrivateCheckbox(e)} 
                    name="privateOnly"
                    defaultChecked={false}
                    type="checkbox"
                    id={`inline-checkbox-3`}
                />
            </Form>
        )
      }
    }

    render(){
        if (!this.props.userTables) {
            return <CatoroSpinner/>
        } else if (this.props.userTables) {
            return (
                <React.Fragment>
                <Container className="w3-container">
                    <h5 className="styleHeading"> {this.props.user.name} <span style={{color: "rgba(251, 77, 61, 1)"}}> Cuppings </span></h5>
                    {this.filterCuppings()}
                    {this.renderUserCuppings()}
                </Container>
            </React.Fragment>
            )
        } 
    }
} 

const msp = state => {
	return {
        isLoggedIn: state.users.isLoggedIn,
        user: state.users.user,
        userTables: state.users.userTables,
	}
  };
  
  export default connect(msp, {
    fetchUserTables,
  })(UserTableCuppings)